import { BaseConfig, Nullable } from '.'

export type Plain = 'string'

export type Config = BaseConfig & {
  type: 'string'
  nullable?: boolean
  defaultValue?: string
}

export type PlainResult = string
export type Result<T extends Config> = Nullable<T, T['array'] extends true ? string[] : string>

const transformValue = (value: any, config?: Config): string | null => {
  const defaultValue = config?.defaultValue ?? ''
  const nullable = config?.nullable ?? false

  if (typeof value === 'boolean') {
    return String(value)
  }
  if (typeof value !== 'string') {
    return nullable ? null : defaultValue
  }

  return value
}

export const transform = (value: any, config?: Config | Plain): string | null | Array<string | null> => {
  if (config === 'string') {
    return transformValue(value)
  }

  const array = config?.array ?? false

  if (array) {
    if (!Array.isArray(value)) {
      return []
    }

    return value.map((item) => transformValue(item, config))
  }

  return transformValue(value, config)
}
